import React, { useRef } from "react";
import "./ThirdReel.css";
import { useScrollReveal } from "../../../custom-hooks/useScrollReveal";

export const ThirdReel = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useScrollReveal(sectionRef, {
    selectorList: [
      ".third-title-container",
      ".third-event:first-child",
      ".third-event:nth-child(2)",
      ".third-event:nth-child(3)",
      ".third-event:nth-child(4)",
    ],
    maxBlur: 8,
    gapFactor: 1.1,
  });

  return (
    <div className="third-section" ref={sectionRef}>
      {/* Fondo blanco de toda la sección */}
      <div className="third-section-overlay">
        {/* Fondo de carta (gris verdoso cuadrado) */}
        <div className="third-card-layer">
          {/* Flores blancas encima */}
          <div className="third-flowers-layer" />

          {/* Fondo beige sobrepuesto (como segunda sección) */}
          <div className="third-green-overlay">
            <div className="third-title-container">
              <span className="third-title-line1">EL</span>
              <span className="third-title-line2">gran</span>
              <span className="third-title-line3">DÍA</span>
            </div>
            <div className="third-timeline">
              <div className="third-event">
                <div className="event-icon icon-church" />
                <div className="event-text">
                  <span>16:00hrs</span>
                  <br />
                  <span>Ceremonia</span>
                </div>
              </div>

              <div className="third-event">
                <div className="event-icon icon-couple" />
                <div className="event-text">
                  <span>20:00hrs</span>
                  <br />
                  <span>Civil</span>
                </div>
              </div>

              <div className="third-event">
                <div className="event-icon icon-glasses" />
                <div className="event-text">
                  <span>21:00hrs</span>
                  <br />
                  <span>Recepción</span>
                </div>
              </div>

              <div className="third-event">
                <div className="event-icon icon-car" />
                <div className="event-text" style={{ paddingTop: 0 }}>
                  <span>02:00hrs</span>
                  <br />
                  <span>Bye Bye!</span>
                </div>
              </div>
            </div>
          </div>

          {/* Badge dorado */}
          <div className="third-badge" />
        </div>
      </div>
    </div>
  );
};
